import React from "react";

import { useTranslation, Trans } from "react-i18next";

import Button from '../Button'

import pic from '../../img/Home/pic.png'

function NeedHelp () {

    const { t } = useTranslation();
      
    return(
        <div className="relative pt-[90px] xl:pt-[200px]">
            <div className="max-w-[1220px] xl:mx-auto flex flex-col justify-center relative xl:h-[342px] xl:rounded-[20px] bg-[#15318D]">
                <div className="flex flex-col items-center xl:mr-auto xl:px-[70px] mt-[40px] xl:mt-0">
                    <p className="text-[#63ABFF] font-[700] text-[28px] xl:text-[45px] open-sans">{t('home.71')}</p>
                    <p className="text-[#FFFFFF] font-[600] text-[17px] xl:text-[19px] open-sans mt-[15px]">{t('home.72')}</p>
                    <Button color={'#EFEFEF'} text={'#0C2780'} className={'mt-[30px] xl:mt-[40px]'}/>             
                </div>
                <img src={pic} className="xl:absolute right-[50px] bottom-0 mt-[50px] px-[20px] xl:px-0" alt="" />
            </div>  
        </div>
    );
}

export default NeedHelp;